<template>
  <div
    class="inline-edittable clip-text"
    :class="{
      editting: editting_,
      'inline-edittable-sm': size === 'sm',
      'inline-edittable-lg': size === 'lg'
    }"
  >
    <div class="overflow-hidden">
      <span
        v-show="!editting_"
        class="inline-edittable-display"
        data-testid="graph-title"
        :class="displayClass"
        @dblclick.prevent="enterEditMode"
      >
        {{ $filters.decodeHTML(value) }}
      </span>
    </div>
    <label
      class="inline-edittable__label--hidden"
      :for="$uuid"
    >
      Title
    </label>
    <input
      v-show="editting_"
      :id="$uuid"
      ref="input"
      v-model="value_"
      type="text"
      :maxlength="maxLength || 80"
      class="inline-edittable-input"
      :class="inputClass"
      data-testid="edit"
      @keyup.enter="persistChanges"
      @keyup.esc="blurInput"
      @blur="exitEditMode"
    >
    <sup
      v-if="!editting_"
      class="inline-edittable-toggle"
      data-testid="start-editing"
      @click.prevent="enterEditMode"
    >
      <elIcon
        name="pencil"
        :size="iconSize"
      />
    </sup>
  </div>
</template>

<script>
import dom from 'Modules/dom'
import elIcon from './elIcon.vue'

export default { components: {
  elIcon
},
props: ['value', 'size', 'displayClass', 'inputClass', 'maxLength', 'iconSize'],
emits: ['changed'],
data() {
  return {
    value_: '',
    editting_: false
  }
},
watch: {
  value(val) {
    if (!this.editting_) {
      this.value_ = val // sync with value from prop
    }
  }
},
mounted() {
  this.value_ = this.$filters.decodeHTML(this.value || '')
},
methods: {
  enterEditMode() {
    this.editting_ = true
    this.$nextTick(() => {
      this.$refs.input.focus()
      dom.selectAllText(this.$refs.input)
    })
  },
  exitEditMode() {
    this.editting_ = false
  },
  blurInput() {
    this.$refs.input.blur()
  },
  persistChanges() {
    if (!this.value_) {
      return
    }
    this.$emit('changed', this.value_)
    this.exitEditMode()
  }
}
}
</script>

<style lang="scss">
@import "~@ui/styles/src/scss/utils/lib";

$inlineEditMaxWidth: 320px;
$inlineEditMaxWidthSm: 160px;
$inlineEditMaxWidthLg: 480px;

.inline-edittable {
  position: relative;
  display: inline-block;
  max-width: $inlineEditMaxWidth;
  padding-right: 1.1em;
  overflow: hidden;
  vertical-align: middle;

  &.inline-edittable-sm {
    max-width: $inlineEditMaxWidthSm;

    > .inline-edittable-input {
      width: $inlineEditMaxWidthSm;
    }
  }

  &.inline-edittable-lg {
    max-width: $inlineEditMaxWidthLg;

    > .inline-edittable-input {
      width: $inlineEditMaxWidthLg;
    }
  }

  &__label--hidden {
    position: absolute;
    visibility: hidden;
  }

  &:hover {
    > .inline-edittable-display {
      margin-bottom: 3px;
      border-bottom: 1px dotted $secondaryColor;
    }
  }

  svg {
    // prevent name of svg from showing up on hover
    pointer-events: none;
  }
}

.editting > .inline-edittable {
  padding-right: 0;
}

.inline-edittable-display {
  display: inline-block;
  margin: 4px 2px;
}

.inline-edittable-input {
  display: inline-block;
  width: $inlineEditMaxWidth;
  margin-top: 2px;
  margin-bottom: 3px;
  padding-bottom: 0;
  color: inherit;
  font-size: inherit;
  background-color: transparent;
  border: 1px solid transparent;

  @include fontSmoothing;

  &:focus {
    border-bottom-color: $secondaryColor;
    outline: 0;
  }
}

.inline-edittable-toggle {
  position: absolute;
  top: 28%;
  right: 0;
  display: block;
  cursor: pointer;

  &:hover {
    color: $primaryColor;
  }
}
</style>
